// extracted by mini-css-extract-plugin
export default {"trend":"src-components-common-Trend-index__trend--nK85o","up":"src-components-common-Trend-index__up--l5Zzd","down":"src-components-common-Trend-index__down--Y8XHY"};